import i18n from 'utility/Translate/I18n';

import { SortOrder } from 'types/Search/form';

import {
    SortOption,
    SortTooltipTranslationKeyMap,
    SortTranslationKeyMap,
} from '../types';

export const RegionSortOption: SortOption[] = [
    {
        value: SortOrder.TopRegion,
        label: i18n.t(SortTranslationKeyMap[SortOrder.TopRegion] ?? ''),
    },
    {
        value: SortOrder.Region,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Region] ?? ''),
    },
    {
        value: SortOrder.TravelDuration,
        label: i18n.t(SortTranslationKeyMap[SortOrder.TravelDuration] ?? ''),
    },
    {
        value: SortOrder.LowestPrice,
        label: i18n.t(SortTranslationKeyMap[SortOrder.LowestPrice] ?? ''),
    },
];
export const HotelSortOption: SortOption[] = [
    {
        value: SortOrder.Popularity,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Popularity] ?? ''),
        tooltip: i18n.t(
            SortTooltipTranslationKeyMap[SortOrder.Popularity] ?? ''
        ),
    },
    {
        value: SortOrder.Price,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Price] ?? ''),
        tooltip: i18n.t(SortTooltipTranslationKeyMap[SortOrder.Price] ?? ''),
    },
    {
        value: SortOrder.Rating,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Rating] ?? ''),
        tooltip: i18n.t(SortTooltipTranslationKeyMap[SortOrder.Rating] ?? ''),
    },
    {
        value: SortOrder.DistanceCityCenter,
        label: i18n.t(
            SortTranslationKeyMap[SortOrder.DistanceCityCenter] ?? ''
        ),
    },
];

export const OfferSortOption: SortOption[] = [
    {
        value: SortOrder.Popularity,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Popularity] ?? ''),
        tooltip: i18n.t(
            SortTooltipTranslationKeyMap[SortOrder.Popularity] ?? ''
        ),
    },
    {
        value: SortOrder.Price,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Price] ?? ''),
        tooltip: i18n.t(SortTooltipTranslationKeyMap[SortOrder.Price] ?? ''),
    },
    {
        value: SortOrder.Rating,
        label: i18n.t(SortTranslationKeyMap[SortOrder.Rating] ?? ''),
        tooltip: i18n.t(SortTooltipTranslationKeyMap[SortOrder.Rating] ?? ''),
    },
    {
        value: SortOrder.DistanceCityCenter,
        label: i18n.t(
            SortTranslationKeyMap[SortOrder.DistanceCityCenter] ?? ''
        ),
    },
];
